import { ReactElement, ReactNode, useEffect, useRef } from 'react';

interface HighlighterProps {
  value: ReactNode;
  disabled?: boolean;
  highlightOnMount?: boolean;
  children: ReactNode;
}

const HIGHLIGHT_CLASS = 'highlighted-background';
const UNHIGHLIGHT_CLASS = 'unhighlighted-background';

const Highlighter = (props: HighlighterProps): ReactElement => {
  const { value, disabled, children, highlightOnMount } = props;

  const containerRef = useRef<HTMLDivElement>(null);
  const highlightOnMountRef = useRef<boolean>(highlightOnMount ?? false);
  const prevValueRef = useRef<ReactNode | undefined>(undefined);

  useEffect(() => {
    const attr = containerRef.current?.className;
    let timeout: NodeJS.Timeout | undefined = undefined;
    const valueChanged =
      prevValueRef.current !== undefined && value !== prevValueRef.current;
    if (disabled !== true && (valueChanged || highlightOnMountRef.current)) {
      if (attr !== HIGHLIGHT_CLASS) {
        if (containerRef.current) {
          if (timeout) {
            clearTimeout(timeout);
          }
          containerRef.current.className = HIGHLIGHT_CLASS;
          timeout = setTimeout(() => {
            if (containerRef.current) {
              containerRef.current.className = UNHIGHLIGHT_CLASS;
            }
          }, 250);
        }
      }
    }
    prevValueRef.current = value;
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [disabled, value, highlightOnMountRef, prevValueRef]);

  return <div ref={containerRef}>{children}</div>;
};

export { Highlighter };
